import FormGroup from '@/components/FormGroup';

export default {
  components: {
    FormGroup,
  },
  props: {
    label: [String, Boolean],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    focus() {
      const input = this.$refs.primaryInput;
      if (input && input.focus) {
        input.focus();
      }
    },
    blur() {
      const input = this.$refs.primaryInput;
      if (input && input.blur) {
        input.blur();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/BaseInput.js